import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTable from "../components/useTable";
import Controls from "../components/controls/Controls";
import { Dimmer } from '../components/spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';

const CatalogoIndole = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })


    const headCells = [
        { id: 'codigo', label: 'CODIGO', width: '50px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'tipoexp', label: 'TIPO EXPENDIO', width: 'auto', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'accion', label: 'OPCIONES', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    ]

    const {TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting} = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idtipoexpendio.includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                           ) {
                            return x;
                        }
                    });
                }
            }
        })

    }


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
        
    }


    const salir = () => {

        props.onHideCancela();
    }

    const seleccionarRegistros = () => {


        let campos = "*"
        let nomtab = "tipoexpendio";
        let orden = "idtipoexpendio";

        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;


        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setRecords(response.data)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    

    const seleccionarindole = (index) => (event) => {

        console.log('listo')
        var id = recordsAfterPagingAndSorting()[index].idtipoexpendio;
        var descrip = recordsAfterPagingAndSorting()[index].descripcion;
        console.log(id,descrip)
        blanquear();
        props.onHideAceptaIndole(id, descrip);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarRegistros()
            }}
        >
            <Modal.Header style={{ backgroundColor: "#019cd5" }}>
                <Modal.Title style={{ color: "#fff" }}>Buscar.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idtipoexpendio} style={{ padding: "0" }}>
                                        <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid" }}>{item.idtipoexpendio}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid" }}>{item.descripcion}</td>
                                
                                        <td align="center" style={{ fontSize: "10px", textAlign: "center",padding: 0, verticalAlign: "middle" ,border: "rgb(14, 101, 238) 1px solid" }}>
                                            <button style={{fontSize: "10px", width: "120px" }} onClick={seleccionarindole(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button  onClick={salir} className="btn btn-danger col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoIndole;